import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import useSEO from "@/lib/useSEO";

export default function AuthCallback() {
  useSEO("Signing In | Fleece The Regime", "Completing sign-in.", true);
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/customer/session", { session_id: sessionId })
      .then((r) => navigate("/account", { state: { user: r.data }, replace: true }))
      .catch(() => navigate("/account", { replace: true }));
  }, [location, navigate]);

  return (
    <main className="pt-32 px-6 min-h-screen font-mono text-sm text-muted-foreground" data-testid="auth-callback">
      Signing you in…
    </main>
  );
}
